import React, { useEffect, useState } from 'react';
import { UiComponents } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import FilterManagement from '../FilterManagement';
import { defaultLogo } from '../../Assets/Icons';
import { useDispatch, useSelector } from 'react-redux';
import { RESOURCE_APPLICATION_TAB } from '../../Constant/constant';
import { checkDataInList } from '../../Utils/general';
import { setToggleResource } from '../../Store/slice/subscriptionSlice';

const { SearchBar, SimCheckBox } = UiComponents;

const ModuleList = ({ selectedCheckboxes, showFilter = true, openFilter, hasMore, loadMoreData, search, setSearch, renderList, heading, placeholder }) => {
    const dispatch = useDispatch();
    const { checkedResource, dateRange } = useSelector((state) => state.subscriptionSlice);

    const [list, setList] = useState([]);

    useEffect(() => {
        setList(renderList);
    }, [renderList]);

    const handleCheckboxChange = (item) => {
        dispatch(setToggleResource({ data: item }));
    };

    return (
        <>
            <div className="colorborder">
                <div className="newsubs-module">
                    <div className="newsubs-module-header">
                        <div className='module-left'>
                            <h5>{heading}</h5>
                            <p>Select the {heading} you want to assign to a group, and role</p>
                        </div>
                        <div className='module-right'>
                            <div className="searchwithborder">
                                <SearchBar
                                    onClick={() => { }}
                                    placeholder={`Search ${placeholder}....`}
                                    value={search}
                                    onChange={(e) => setSearch(e)}
                                />
                            </div>
                            {showFilter && <FilterManagement openFilter={openFilter} selectedCheckboxes={selectedCheckboxes} />}
                        </div>
                    </div>
                    <div className='new-module-content' id="scrollableDivResources">

                        <InfiniteScroll
                            scrollThreshold={0.7}
                            dataLength={list.length}
                            next={() => loadMoreData()}
                            hasMore={hasMore}
                            // loader={<ResourceManagementSkelton length="4" width={activeTab === RESOURCE_APPLICATION_TAB ? "50px" : "70px"} circle={activeTab === RESOURCE_APPLICATION_TAB ? true : false} />}
                            loader={<p>Loading....</p>}
                            scrollableTarget="scrollableDivResources"
                        >
                            <>
                                {list.map((item) => (
                                    <div className="new-module-list" key={item.id}>
                                        <SimCheckBox
                                            checked={checkDataInList(checkedResource, item)}
                                            onChange={() => handleCheckboxChange(item)}
                                        />
                                        <div className='new-module-list-data'>
                                            <img src={item.icon || defaultLogo} alt={item.title} />
                                            <h6>{item.title}</h6>
                                        </div>
                                    </div>
                                ))}
                            </>
                        </InfiniteScroll>



                    </div>
                </div>
            </div>
        </>
    );
};

export default ModuleList;
